import type { ConnectionPropertiesSchema } from "../../data-sources/schemas";

/**
 * The reconnectPath to auto-redirect to when exactly one connection needs reconnecting, or
 * `undefined` when none/more than one do (the list is shown instead, so the user picks).
 *
 * `hasOauthError` must be true when the panel has just reopened after a failed attempt (an
 * `oauth-error` on the URL) — otherwise a persistently-broken connection would auto-redirect,
 * fail, reopen, and auto-redirect again with no user action in between. In that case the user
 * sees the OAuthErrorBanner instead and has to click Reconnect themselves to retry.
 */
export const getAutoInitiateReconnectPath = (
  connections: ConnectionPropertiesSchema[],
  hasOauthError: boolean
): string | undefined => {
  if (hasOauthError) {
    return undefined;
  }
  const disconnected = connections.filter((connection) => !connection.isConnected && connection.reconnectPath);
  return disconnected.length === 1 ? (disconnected[0].reconnectPath as string) : undefined;
};
